import theme from '../../../../../lib/theme';
const {
	layouts,
	colors,
	scale,
	media,
	mediaSizes,
	font: { families, heights, spacings, ...font },
} = theme;
export default () => ({
	homepageLayout: {
		display: 'flex',
		width: '100%',
		maxWidth: mediaSizes.xxl,

		[`@media (max-width: ${mediaSizes.xxl}px)`]: {
			padding: `0 0.5em!important`,
		}
	},
	layoutColumns: {
		gap: '1em',

		'> div': {
			width: `100%`,
			maxWidth: `100%`,
			
			[media.xl.down]: {
				// width: `100%!important`,
				// maxWidth: `100%!important`,
			}
		},

		[media.xl.down]: {
			flexDirection: 'column',
		}
	},
	ad: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',

		'&:before': {
			content: '"-Advertisement-"',
			display: 'block',
			fontSize: '0.7em',
			color: 'rgba(102, 102, 102, 0.7)',
			textAlign: 'center',
		},
	},

	// #region progressive layout
	progressive: {
		width: '100%',
		maxWidth: '100%',
	},
	progressiveOne: {
		display: 'flex',
		alignItems: 'stretch',
		gap: scale.xxs,

		[media.m.down]: {
			flexDirection: 'column',
		},
	},
	progressiveTwo: {
		display: 'flex',
		gap: scale.xxs,

		[media.m.down]: {
			flexDirection: 'column',

			// When stacked, let aspect-ratio set the height so the image-only
			// overlay tiles don't collapse (flex-basis 0 would zero the height).
			'& .progressiveOverlayTile': {
				flex: '1 1 auto',
			},
		},
	},
	progressiveThree: {
		display: 'flex',
		alignItems: 'stretch',
		gap: scale.xxs,

		// Tablet (below xl): three equal-width columns, still a row. The hero takes
		// one part and the pair container two parts, so hero + tile2 + tile3 are all
		// ~a third each.
		[media.xl.down]: {
			'& > .progressiveThreeStack': {
				flex: '2 1 0',
			},
		},

		// Mobile: stack all three vertically. Class selectors (not `> *`) so these
		// beat the tiles' own base `flex: 1 1 0` and let aspect-ratio drive height —
		// otherwise the image-only hero overlay collapses to zero.
		[media.m.down]: {
			flexDirection: 'column',

			'& > .progressiveOverlayTile': {
				flex: '1 1 auto',
			},
			'& > .progressiveThreeStack': {
				flex: '1 1 auto',
			},
		},
	},
	progressiveThreeStack: {
		display: 'flex',
		flex: '1 1 0',
		flexDirection: 'row',
		gap: scale.xxs,

		// Mobile: the pair stacks vertically along with the hero.
		[media.m.down]: {
			flexDirection: 'column',
		},

		// Desktop only (media.xl.up): the pair sits beside the hero and stretches to
		// its height, so let each side image FILL that height — the wrap flex-grows
		// to fill the tile and the image absolute-fills the wrap (object-fit cover).
		// Below xl the block stacks under the hero, so the base 16/10 aspect applies
		// and images keep a natural height (no collapse). Scoped here so the 4-up
		// grid's fixed-aspect stacked tiles are unaffected.
		[media.xl.up]: {
			'& .progressiveStackedImageWrap': {
				display: 'flex',
				position: 'relative',
				flex: '1 1 auto',
				minHeight: 0,
			},
			'& .progressiveStackedImage': {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				aspectRatio: 'auto',
				objectFit: 'cover',
			},
		},
	},
	progressiveFour: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		gap: scale.xxs,

		// Compact 2x2: each tile matches the 2-up tile height; the image fills
		// the space above the title (object-fit cover).
		'& .progressiveStackedTile': {
			height: '280px',
		},
		'& .progressiveStackedImageWrap': {
			position: 'relative',
			flex: '1 1 auto',
			minHeight: 0,
		},
		'& .progressiveStackedImage': {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			aspectRatio: 'auto',
			objectFit: 'cover',
		},

		[media.m.down]: {
			gridTemplateColumns: '1fr',
		},
	},

	// split tile (1 article)
	progressiveSplitTile: {
		display: 'flex',
		flex: '1 1 auto',
		gap: scale.s,
		textDecoration: 'none',
		color: colors.black,

		'&:hover': {
			textDecoration: 'none',
			'.progressiveSplitTitle': {
				textDecoration: 'underline',
			},
		},

		[media.m.down]: {
			flexDirection: 'column',
		},
	},
	progressiveSplitImageWrap: {
		flex: '0 0 50%',
		maxWidth: '50%',

		[media.m.down]: {
			flex: '1 1 auto',
			maxWidth: '100%',
		},
	},
	progressiveSplitImage: {
		display: 'block',
		width: '100%',
		height: '100%',
		aspectRatio: '16 / 10',
		objectFit: 'cover',
	},
	progressiveSplitContent: {
		display: 'flex',
		flex: '1 1 50%',
		flexDirection: 'column',
		justifyContent: 'center',
		gap: scale.xs,
		paddingRight: scale.xs,

		[media.m.down]: {
			padding: `0 ${scale.xs} ${scale.xs}`
		},
	},
	progressiveSplitTitle: {
		fontSize: '1.5em',
		fontWeight: 600,
		lineHeight: '1.2em',
		color: colors.black,
	},
	progressiveSplitExcerpt: {
		fontSize: font.s,
		color: colors.black,
	},

	// overlay tile (2 articles + 3-article hero)
	progressiveOverlayTile: {
		position: 'relative',
		display: 'block',
		flex: '1 1 0',
		aspectRatio: '16 / 10',
		overflow: 'hidden',
		textDecoration: 'none',

		'&:before': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			background: 'linear-gradient(to top, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.15) 45%, rgba(0, 0, 0, 0) 70%)',
			zIndex: 1,
		},

		'&:hover': {
			'.progressiveOverlayTitle': {
				textDecoration: 'underline',
			},
		},
	},
	progressiveOverlayImage: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		objectFit: 'cover',
	},
	progressiveOverlayTitle: {
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		zIndex: 2,
		padding: scale.s,
		color: colors.white,
		fontSize: '1.15em',
		fontWeight: 400,
		lineHeight: '1.25em',
	},

	// stacked tile (3-article column + 4-article grid)
	progressiveStackedTile: {
		display: 'flex',
		flex: '1 1 0',
		minWidth: 0,
		flexDirection: 'column',
		textDecoration: 'none',
		color: colors.black,

		'&:hover': {
			'.progressiveStackedTitle': {
				textDecoration: 'underline',
			},
		},
	},
	progressiveStackedImageWrap: {
		width: '100%',
		overflow: 'hidden',
	},
	progressiveStackedImage: {
		display: 'block',
		width: '100%',
		aspectRatio: '16 / 10',
		objectFit: 'cover',
	},
	progressiveStackedTitle: {
		fontSize: font.m,
		fontWeight: 400,
		lineHeight: '1.25em',
		color: colors.black,
		paddingTop: scale.xs,
	},
	// #endregion progressive layout
});